import React from 'react';
import { observer } from 'mobx-react-lite';
import { X } from 'lucide-react';
import EditManualBookingForm from './edit-manual-booking-form';
import { useTranslation } from 'react-i18next';
import { useCalendarViewModel } from "../../view-model/professional/calendar-view-model";

const EditManualBookingModal: React.FC = () => {
  const calendarViewModel = useCalendarViewModel();
  const { t } = useTranslation();

  if (!calendarViewModel.getShowEditManualBookingModal || !calendarViewModel.getBookingToEdit) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white dark:bg-gray-900 rounded-xl shadow-2xl w-full max-w-2xl max-h-[90vh] flex flex-col overflow-hidden">
        <div className="px-6 py-4 border-b border-gray-200 dark:border-gray-700 flex justify-between items-center flex-shrink-0">
          <h2 className="text-xl font-semibold text-gray-900 dark:text-gray-100">
            {t('calendar.editManualBooking', 'Modifier la réservation')}
          </h2>
          <button
            onClick={() => calendarViewModel.closeEditManualBookingModal()}
            className="rounded-full p-2 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
            aria-label="Fermer"
          >
            <X size={20} className="text-gray-500 dark:text-gray-400" />
          </button>
        </div>

        <EditManualBookingForm
          booking={calendarViewModel.getBookingToEdit}
          onSuccess={() => calendarViewModel.closeEditManualBookingModal()}
          onCancel={() => calendarViewModel.closeEditManualBookingModal()}
        />
      </div>
    </div>
  );
};

export default observer(EditManualBookingModal);
